import { createNamedContext } from "../../helpers/context";
export var DialogContext = createNamedContext('DialogContext', {});